import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { NgFor, NgTemplateOutlet } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { DropdownContentDirective } from '../dropdown/dropdown-content.directive';
import { DropdownTriggerDirective } from '../dropdown/dropdown-trigger.directive';
import { DropdownComponent } from '../dropdown/dropdown.component';

@Component({
    selector: 'kbart-combo-box',
    templateUrl: 'combo-box.component.html',
    styleUrls: ['combo-box.component.scss'],
    standalone: true,
    imports: [
        DropdownComponent,
        DropdownTriggerDirective,
        FontAwesomeModule,
        DropdownContentDirective,
        NgFor,
        NgTemplateOutlet,
    ],
})
export class ComboBoxComponent<T> {
    @Input() items: T[];
    @Input() closeOnItemClick = true;
    @Input() closeButton = false;
    @Output() itemClick = new EventEmitter<T>();
    @ContentChild('comboBoxItem', { read: TemplateRef }) itemTemplate: TemplateRef<any>;
    protected readonly chevronDown = faChevronDown;
}
